export default "__VITE_ASSET__1ZVuTIAw__"